import { useMutation } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

import { axios } from "../axios"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { API_SBP_OUTCOME_PAYMENTS_URL } from "../constants"


interface CreatePaymentRequest {
  qrcId: string,
  amount: number,
  idempotencyKey: string,
  token: string
}

interface CreatePaymentResponse {
  outcomePaymentId: string
}

interface CreatePaymentParams {
  qrcId: string,
  amount: number,
}

const createPayment = async ({ token, idempotencyKey, ...data }: CreatePaymentRequest) => {
  const response = await axios(`${API_SBP_OUTCOME_PAYMENTS_URL}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Idempotency-Key': idempotencyKey,
    },
    data,
  })

  if (checkIsFailure(response.status)) {
    throw new Error(
      `Ошибка при создании платежа: ${response.status} - ${response.statusText}`,
    )
  }

  return response.data
}

export const useCreateC2BPayment = () => {
  const navigate = useNavigate()
  const token = useSelector((state: RootState) => state.auth.token)
  const idempotencyKey = crypto.randomUUID()

  return useMutation<CreatePaymentResponse, Error, CreatePaymentParams>({
    mutationFn: ({ qrcId, amount }: CreatePaymentParams) =>
      createPayment({
        qrcId,
        amount,
        token: token || "",
        idempotencyKey,
      }),
    onError: () => {
      navigate("/error")
    },
  })
}